export enum Routes {
  Callback = '/callback',
  SurveyUI = '/survey',
  CandidateForm = '/candidate',
  Dashboard = '/dashboard',
  Candidates = '/dashboard/candidates',
  Positions = '/dashboard/positions',
  Surveys = '/dashboard/surveys',
  Prospects = '/dashboard/prospects',
  Settings = '/settings',
  ProfileSettings = '/settings/profile',
  NotificationsSettings = '/settings/notifications',
  MessagesSettings = '/settings/messages',
  UsersSettings = '/settings/users',
  PermissionsSettings = '/settings/permissions',
  CompanySettings = '/settings/company',
  CandidateFormSettings = '/settings/form',
  CandidateFormPreview = '/settings/form/preview',
  Integrations = '/settings/integrations',
  ApiTokens = '/settings/tokens',
  DefaultCounters = '/settings/counters',
  SurveyPreview = '/survey-preview',
  InactiveUserPage = '/404',
  ManualInput = '/manual-input',
  IntegrationsCallback = '/integration-callback'
}
